import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";

function PutAway_BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/PutAway" ? (
        <div>
          <span className="breadcrumb-not-active ">PutAway </span>
        </div>
      ) : vPathName === "/PutAwayDetail" ? (
        <div className={"d-flex align-items-center"}>
          <Link
            to="/PutAway"
            state={location}
            className={"breadcrumb-active mr-2"}
          >
            PutAway
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span className="breadcrumb-not-active">PutAwayDetail </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default PutAway_BreadCrumbs;
